import {dispatcher} from 'store/helpers';
import * as actions from './actions/goals';

export * from './actions/goals';
export * from './selectors/categories';
export * from './selectors/examples';
export * from './selectors/goal';
export * from './selectors/goals';
export * from './selectors/list';
export * from './selectors/plan';
export * from './selectors/progress';
export * from './selectors/projects';
export * from './selectors/stats';
export * from './selectors/templates';
export const dispatch = dispatcher(actions);
